import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { apiRequest } from "../apiService/allapi";
import { successAlert, errorAlert } from "../apiService/sweetAlert";
import { logout } from "../helper/authUtils.jsx";
import { confirmAlert } from "../apiService/sweetAlert";
const User = () => {
  const [activeTab, setActiveTab] = useState("edit-profile");
  const [showPassword, setShowPassword] = useState(false);
  const [showChangePassword, setShowChangePassword] = useState(false);
  const [sidebarActive, setSidebarActive] = useState(false);
  const [userProfile, setUserProfile] = useState({
    name: "",
    email: "",
    mobile: "",
    address: "",
    gender: "",
  });
  const [orderDetails, setOrderDetails] = useState(null);
  const [detailsLoading, setDetailsLoading] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const [ratingMap, setRatingMap] = useState({});
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [showReturnModal, setShowReturnModal] = useState(false);
  const [returnOrderId, setReturnOrderId] = useState(null);
  const [returnReason, setReturnReason] = useState("");
  // ✅ 1. State (sabse pehle)
  const [orders, setOrders] = useState([]);
  const [orderFilter, setOrderFilter] = useState("delivered");
  const [currentPage, setCurrentPage] = useState(1);
  const ordersPerPage = 5;
  const [showOrderDetailsModal, setShowOrderDetailsModal] = useState(false);
  const [orderDetailsError, setOrderDetailsError] = useState(""); // for "No orders found."

  // ✅ 2. Status function
  const getStatus = (order) => {
    if (!order) return "";

    if (order.isCancel) return "cancelled";
    if (order.isDeliver) return "delivered";
    return "processing";
  };

  // ✅ 3. Filter (IMPORTANT: state ke baad hi)
  const filteredOrders = Array.isArray(orders)
    ? orders.filter((order) => getStatus(order) === orderFilter)
    : [];

  // ✅ Pagination logic
  const totalPages = Math.ceil(filteredOrders.length / ordersPerPage);
  const paginatedOrders = filteredOrders.slice(
    (currentPage - 1) * ordersPerPage,
    currentPage * ordersPerPage,
  );

  const goToPrevPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };
  const goToNextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };
  const goToPage = (page) => {
    setCurrentPage(page);
  };

  useEffect(() => {
    setCurrentPage(1);
  }, [orderFilter]);

  // ✅ 1. Sabse pehle state
  const [legalLinks, setLegalLinks] = useState([]);
  const [selectedAddressId, setSelectedAddressId] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [profileFormData, setProfileFormData] = useState({
    MemberName: "",
    email: "",
    mobile: "",
    gender: "",
    address: "",
  });
  const [showAddressForm, setShowAddressForm] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [cancelOrderId, setCancelOrderId] = useState(null);
  const [cancelReason, setCancelReason] = useState("");
  const [addresses, setAddresses] = useState([]);
  const [isSaving, setIsSaving] = useState(false);
  const [addressForm, setAddressForm] = useState({
    id: null,
    name: "",
    email: "",
    phone: "",
    country: "",
    state: "",
    city: "",
    pincode: "",
    address: "",
  });

  // dropdown data
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const token = localStorage.getItem("token");

  // Mock data for other sections (reward points, orders, addresses)
  const [rewardPoints, setRewardPoints] = useState({
    total: 0,
    history: [],
  });
  const [passwordData, setPasswordData] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  // Fetch real user profile on component mount
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      setError("Please login to view dashboard");
      setLoading(false);
      return;
    }

    const fetchProfile = async () => {
      if (!token) {
        console.error("❌ No token - login first!");
        setError("Please login first");
        setLoading(false);
        return;
      }
      try {
        setLoading(true);
        const res = await apiRequest("/User/get-profile", "GET", null, {
          Authorization: `Bearer ${token}`,
        });

        if (res?.data?.status === true) {
          const profileData = res.data.data || {};
          setUserProfile(profileData);
          setProfileFormData({
            MemberName: profileData.MemberName || profileData.memberName || "",
            email: profileData.email || "",
            mobile: profileData.mobile || "",
            gender: profileData.gender || "",
            address: profileData.address || "",
          });
        } else {
          setError(res?.data?.message || "Failed to fetch profile");
        }
      } catch (err) {
        console.error(
          "❌ Profile fetch ERROR:",
          err.response?.data || err.message || err,
        );
        setError(
          `API Error: ${err.response?.data?.message || err.message || "Unknown error"}`,
        );
      } finally {
        setLoading(false);
      }
    };

    fetchProfile();
    fetchRewardPoints(); // 👈 add this
  }, []);

  const sidebarController = () => {
    setSidebarActive(!sidebarActive);
  };

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setSidebarActive(false);
  };

  const handleLogout = () => {
    confirmAlert("Logout", "Are you sure you want to logout?").then(
      (result) => {
        if (result.isConfirmed) {
          logout();
        }
      },
    );
  };

  // update profile
  const handleUpdateProfile = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);
      const formData = new FormData();

      formData.append("MemberName", profileFormData.MemberName);
      formData.append("Email", profileFormData.email);
      formData.append("Mobile", profileFormData.mobile);
      formData.append("Gender", profileFormData.gender);
      formData.append("Address", profileFormData.address);

      // ❗ ONLY send if real file exists
      if (profileFormData.ProfileImage) {
        formData.append("ProfileImage", profileFormData.ProfileImage);
      }

      // ✅ FIX HERE
      const res = await apiRequest("/User/update-profile", "POST", formData, {
        Authorization: `Bearer ${token}`,
      });
      if (res?.data?.status === true || res?.data?.success === true) {
        successAlert(res?.data?.message);
      } else {
        errorAlert(res?.data?.message);
      }
    } catch (err) {
      console.error(err);
      errorAlert("Something went wrong");
    } finally {
      setLoading(false);
    }
  };
  // rewards api
  const fetchRewardPoints = async () => {
    try {
      const res = await apiRequest("/User/getRewardPoints", "GET", null, {
        Authorization: `Bearer ${token}`,
      });

      if (res?.data?.success === true) {
        setRewardPoints({
          total: res.data.data.totalPoints || 0,
          history: res.data.data.history || [],
        });
      }
    } catch (error) {
      console.error("Reward points error:", error);
    }
  };
  // chnage password
  const handlePasswordChange = async (e) => {
    e.preventDefault();

    if (passwordData.newPassword !== passwordData.confirmPassword) {
      errorAlert("New password and confirm password do not match");
      return;
    }

    try {
      setLoading(true);

      const payload = {
        oldPassword: passwordData.currentPassword,
        newPassword: passwordData.newPassword,
        repeatNewPassword: passwordData.confirmPassword,
      };

      const res = await apiRequest("/Auth/changePassword", "POST", payload, {
        Authorization: `Bearer ${token}`,
      });

      if (res?.data?.success === true) {
        successAlert(res?.data?.message);

        setPasswordData({
          currentPassword: "",
          newPassword: "",
          confirmPassword: "",
        });
      } else {
        errorAlert(res?.data?.message);
      }
    } catch (error) {
      console.error(error);
      errorAlert("Something went wrong");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getCountries();
  }, []);
  const getCountries = async () => {
    try {
      const res = await apiRequest("/Common/Country/list", "GET");
      setCountries(res.data.data.data || []);
    } catch (error) {
      setCountries([]);
    }
  };

  const getStates = async (countryId) => {
    try {
      const res = await apiRequest(`/Common/State/${countryId}`, "GET");
      setStates(res.data.data || []);
    } catch (error) {
      setStates([]);
    }
  };

  const getCities = async (stateId) => {
    try {
      const res = await apiRequest(`/Common/api/common/city/${stateId}`, "GET");
      setCities(res.data.data || []);
    } catch (error) {
      setCities([]);
    }
  };

  // update adress api
  const handleSaveAddress = async () => {
    if (!addressForm.name || !addressForm.phone || !addressForm.address) {
      errorAlert("Please fill required fields");
      return;
    }
    setIsSaving(true);
    try {
      let res;

      if (isEditMode) {
        // 🔥 UPDATE API CALL
        const payload = {
          id: addressForm.id ? Number(addressForm.id) : 0, // 🔥 IMPORTANT

          name: addressForm.name,
          email: addressForm.email,
          mobile: addressForm.phone,

          countryID: Number(addressForm.country),
          stateID: Number(addressForm.state),
          cityID: Number(addressForm.city),

          address: addressForm.address,
          pinCode: addressForm.pincode,

          cityName:
            cities.find((c) => c.cityID == addressForm.city)?.cityName || "NA",

          isDefault: false, // ya true (agar default banana hai)
        };

        res = await apiRequest("/User/update-address", "POST", payload, {
          Authorization: `Bearer ${token}`,
        });
      } else {
        // 🔥 ADD API CALL
        const payload = {
          id: addressForm.id ? Number(addressForm.id) : 0,

          name: addressForm.name,
          email: addressForm.email,
          mobile: addressForm.phone,

          countryID: Number(addressForm.country),
          stateID: Number(addressForm.state),
          cityID: Number(addressForm.city),

          address: addressForm.address,
          pinCode: addressForm.pincode,

          cityName:
            cities.find((c) => c.cityID == addressForm.city)?.cityName || "NA",

          isDefault: true, // ya false
        };

        res = await apiRequest("/User/add-address", "POST", payload, {
          Authorization: `Bearer ${token}`,
        });
      }

      // ✅ SUCCESS
      if (res?.data?.status === true) {
        console.log("Address save response:", res.data);

        // Optimistic UI update
        if (!isEditMode) {
          // Add new address optimistically
          const newAddr = {
            id: `temp_${Date.now()}`,
            name: addressForm.name,
            email: addressForm.email,
            phone: addressForm.phone,
            mobile: addressForm.phone,
            countryID: addressForm.country,
            stateID: addressForm.state,
            cityID: addressForm.city,
            pinCode: addressForm.pincode,
            address: addressForm.address,
            cityName: "",
            stateName: "",
            isDefault: addresses.length === 0,
          };
          setAddresses((prev) => [newAddr, ...prev]);
        } else {
          // Update existing
          setAddresses((prev) =>
            prev.map((addr) =>
              addr.id == addressForm.id
                ? {
                    ...addr,
                    name: addressForm.name,
                    phone: addressForm.phone,
                    email: addressForm.email,
                    address: addressForm.address,
                    pincode: addressForm.pincode,
                    countryID: addressForm.country,
                    stateID: addressForm.state,
                    cityID: addressForm.city,
                  }
                : addr,
            ),
          );
        }

        successAlert(
          isEditMode
            ? "Address updated successfully"
            : "Address added successfully",
        );

        setShowAddressForm(false);
        setIsEditMode(false);
        setAddressForm({
          id: null,
          name: "",
          email: "",
          phone: "",
          country: "",
          state: "",
          city: "",
          pincode: "",
          address: "",
        });
        fetchAddresses();
      } else {
        errorAlert(res?.data?.message || "Something went wrong");
      }
    } catch (error) {
      console.error(error);
      errorAlert("Server error");
    } finally {
      setIsSaving(false);
    }
  };
  // fech adress api
  const fetchAddresses = async () => {
    try {
      const token = localStorage.getItem("token");

      const res = await apiRequest("/User/get-addresses", "GET", null, {
        Authorization: `Bearer ${token}`,
      });

      if (res?.data?.status === true) {
        setAddresses(res.data.data || []);
      }
    } catch (error) {
      console.error("Address fetch error", error);
    }
  };
  useEffect(() => {
    if (token) {
      fetchAddresses();
    }
  }, [token]);
  // defualt api call adress
  const handleSetDefault = async (id) => {
    setSelectedAddressId(id);

    try {
      const res = await apiRequest(
        `/User/SetDefaultAddress?addressId=${id}`, // ✅ correct
        "POST",
        null,
        {
          Authorization: `Bearer ${token}`,
        },
      );

      console.log("Default API response:", res.data);
      console.log("Sending ID:", id);
      if (res?.data?.status === true) {
        successAlert(res.data.message); // 👈 backend message use karo
        // window.location.reload(); // ✅ API ke baad reload
        fetchAddresses(); // ✅ refresh list
        window.dispatchEvent(new Event("addressUpdated"));
      } else {
        errorAlert(res?.data?.message);
      }
    } catch (error) {
      console.error(error);
      errorAlert(error?.response?.data?.message || "Something went wrong");
    }
  };
  useEffect(() => {
    const defaultAddr = addresses.find((a) => a.isDefault);
    if (defaultAddr) {
      setSelectedAddressId(defaultAddr.id);
    }
  }, [addresses]);
  // legal and ploicy api
  const fetchLegalLinks = async () => {
    try {
      const res = await apiRequest("/LegalPolicies/legalAndPolicies", "GET");

      if (res?.data) {
        setLegalLinks(res.data);
      }
    } catch (error) {
      console.error("Legal API error:", error);
    }
  };
  useEffect(() => {
    fetchLegalLinks();
  }, []);
  // orders details api
  useEffect(() => {
    fetchOrders();
  }, []);

  const fetchOrders = async () => {
    try {
      const res = await apiRequest("/Order/UserOrders", "GET", null, {
        Authorization: `Bearer ${token}`,
      });

      setOrders(Array.isArray(res?.data?.data) ? res.data.data : []);
    } catch (error) {
      console.error("Order API error:", error);
      setOrders([]);
    }
  };

  // retrun order api
  const handleReturnOrder = async () => {
    if (!returnReason) {
      errorAlert("Please enter return reason");
      return;
    }

    try {
      const payload = {
        orderId: returnOrderId,
        remark: returnReason,
      };

      const res = await apiRequest("/Order/OrderReturn", "POST", payload, {
        Authorization: `Bearer ${token}`,
      });

      if (res?.data?.status === true) {
        successAlert(res.data.message || "Return requested");

        setShowReturnModal(false);
        setReturnReason("");
        setReturnOrderId(null);

        fetchOrders();
      } else {
        errorAlert(res?.data?.message);
      }
    } catch (error) {
      errorAlert("Return failed");
    }
  };
  // candel oder api
  const handleCancelOrder = async () => {
    if (!cancelReason) {
      errorAlert("Please enter cancel reason");
      return;
    }

    try {
      const payload = {
        orderId: cancelOrderId,
        remark: cancelReason,
      };

      const res = await apiRequest("/Order/cancel-order", "POST", payload, {
        Authorization: `Bearer ${token}`,
      });

      if (res?.data?.status === true) {
        successAlert("Order cancelled successfully");

        setShowCancelModal(false);
        setCancelReason("");
        setCancelOrderId(null);

        fetchOrders(); // refresh
      } else {
        errorAlert(res?.data?.message);
      }
    } catch (error) {
      errorAlert("Cancel failed");
    }
  };
  // api rating product
  const handleSubmitRating = async (order) => {
    const data = ratingMap[order.id];

    if (!data?.rating) {
      errorAlert("Please select rating");
      return;
    }

    const productId =
      order.pid || // 🔥 MAIN FIX
      order.productId ||
      order.productID ||
      order.ProductId ||
      order.product_id;

    if (!productId) {
      console.error("❌ ProductId missing:", order);
      errorAlert("ProductId not found");
      return;
    }

    try {
      const payload = {
        orderId: order.id,
        productId: productId,
        rating: data.rating,
        remark: data.remark,
      };

      console.log("📦 Payload:", payload);

      const res = await apiRequest("/Order/productRating", "POST", payload, {
        Authorization: `Bearer ${token}`,
      });

      if (res?.data?.status === true) {
        successAlert("Rating submitted");

        setRatingMap({
          ...ratingMap,
          [order.id]: { rating: 0, remark: "" },
        });

        setShowDetailsModal(false);
      } else {
        errorAlert(res?.data?.message);
        setShowDetailsModal(false); // ✅ ADD THIS
      }
    } catch (error) {
      console.error(error);
      errorAlert("Rating failed");
      setShowDetailsModal(false); // ✅ ADD THIS
    }
  };

  // user order details api
  const handleViewDetails = async (invoiceNo) => {
    try {
      setDetailsLoading(true);
      setShowOrderDetailsModal(true);

      const res = await apiRequest(
        `/Order/UserOrdersDetails?invoiceNo=${invoiceNo}`,
        "GET",
        null,
        {
          Authorization: `Bearer ${token}`,
        },
      );

      console.log("Order Details:", res.data);

      if (res?.data?.status === true) {
        const details = res.data.data;
        if (
          details.id === 0 ||
          !details.invoiceNo ||
          res.data.message === "No orders found."
        ) {
          setOrderDetailsError(res.data.message || "No order details found.");
          setOrderDetails(null);
        } else {
          setOrderDetails(details);
          setOrderDetailsError("");
        }
      } else {
        setOrderDetailsError(res?.data?.message || "Details not found");
        setOrderDetails(null);
      }
    } catch (error) {
      console.log("Details Error:", error);
      setOrderDetailsError("Something went wrong");
      setOrderDetails(null);
    } finally {
      setDetailsLoading(false);
    }
  };

  return (
    <>
      <section className="user-dashboard py-120 bg-color-one">
        <div
          className={`side-overlay ${sidebarActive ? "show" : ""}`}
          onClick={sidebarController}
        ></div>
        <div className="container container-lg">
          <div className="row">
            {/* Sidebar */}
            <div className="col-lg-3">
              <div className={`user-sidebar ${sidebarActive && "active"}`}>
                <button
                  onClick={sidebarController}
                  className="user-sidebar__close d-lg-none d-flex w-32 h-32 flex-center border border-gray-100 rounded-circle hover-bg-main-600 position-absolute inset-inline-end-0 me-10 mt-8 hover-text-white hover-border-main-600 z-10"
                >
                  <i className="ph ph-x" />
                </button>

                {/* Profile Card */}
                <div className="user-sidebar__profile border border-gray-100 rounded-8 p-32 mb-32 text-center bg-gray-50">
                  <div className="w-80 h-80 rounded-circle bg-main-100 flex-center mx-auto mb-16 position-relative overflow-hidden">
                    <i className="ph ph-user text-3xl text-main-600" />
                  </div>
                  <h6 className="text-xl fw-semibold mb-4 text-truncate">
                    {userProfile.memberName}
                  </h6>
                  <p className="text-gray-600 mb-12 text-truncate px-4">
                    {userProfile.email}
                  </p>

                  <span className="badge bg-gradient text-black px-20 py-10 fs-5 fw-semibold">
                    {rewardPoints.total} <i className="ph ph-coins ms-4" />
                  </span>
                </div>

                {/* Navigation */}
                <nav className="user-sidebar__nav flex-grow-1">
                  <ul className="list-unstyled nav-list">
                    <li className="my-4 text-black">
                      <button
                        className={`nav-link ${activeTab === "edit-profile" && "active"}`}
                        onClick={() => handleTabChange("edit-profile")}
                      >
                        <i className="ph ph-user-circle text-xl me-12" />
                        Edit Profile
                      </button>
                    </li>
                    <li className="my-4 text-black">
                      <button
                        className={`nav-link ${activeTab === "rewards" && "active"}`}
                        onClick={() => handleTabChange("rewards")}
                      >
                        <i className="ph ph-coins text-xl me-12" />
                        Reward Points
                      </button>
                    </li>
                    <li className="my-4 text-black">
                      <button
                        className={`nav-link ${activeTab === "orders" && "active"}`}
                        onClick={() => handleTabChange("orders")}
                      >
                        <i className="ph ph-shopping-bag text-xl me-12" />
                        My Orders
                      </button>
                    </li>
                    <li className="my-4 text-black">
                      <button
                        className={`nav-link ${activeTab === "address" && "active"}`}
                        onClick={() => handleTabChange("address")}
                      >
                        <i className="ph ph-map-pin-line text-xl me-12" />
                        My Address
                      </button>
                    </li>
                    <li className="my-4 text-black">
                      <button
                        className={`nav-link ${activeTab === "settings" && "active"}`}
                        onClick={() => handleTabChange("settings")}
                      >
                        <i className="ph ph-gear text-xl me-12" />
                        Settings
                      </button>
                    </li>
                    <li className="my-4 text-black">
                      <button
                        className={`nav-link ${activeTab === "legal" && "active"}`}
                        onClick={() => handleTabChange("legal")}
                      >
                        <i className="ph ph-file-text text-xl me-12" />
                        Legal & Policies
                      </button>
                    </li>
                  </ul>
                </nav>

                {/* Logout */}
                <div className="border-t border-gray-200 pt-24 mt-auto">
                  <button
                    className="btn btn-danger w-100 py-16 px-20 text-white fw-semibold rounded-8"
                    onClick={handleLogout}
                  >
                    <i className="ph ph-sign-out me-12" />
                    Logout
                  </button>
                </div>
              </div>
            </div>

            {/* Main Content */}
            <div className="col-lg-9">
              <button
                type="button"
                className="user-dashboard__toggle btn btn-main d-lg-none mb-24 px-20 py-12"
                onClick={sidebarController}
              >
                <i className="ph ph-list me-8" />
                Menu
              </button>
              {activeTab === "edit-profile" && (
                <div className="content-card">
                  <div className="d-flex justify-content-between align-items-center mb-32">
                    <h4 className="h3 fw-bold text-neutral-900 mb-0">
                      Edit Profile
                    </h4>
                    <button className="btn btn-outline-secondary px-24 py-12">
                      <i className="ph ph-arrow-left me-8" />
                      Back
                    </button>
                  </div>
                  <form onSubmit={handleUpdateProfile}>
                    <div className="row g-4">
                      <div className="col-md-6">
                        <label className="form-label fw-semibold text-lg mb-12">
                          Name <span className="text-danger">*</span>
                        </label>
                        <input
                          className="form-control common-input"
                          value={profileFormData.MemberName}
                          onChange={(e) =>
                            setProfileFormData({
                              ...profileFormData,
                              MemberName: e.target.value,
                            })
                          }
                          required
                        />
                      </div>

                      <div className="col-md-6">
                        <label className="form-label fw-semibold text-lg mb-12">
                          Email
                        </label>
                        <input
                          className="form-control common-input"
                          type="email"
                          value={profileFormData.email}
                          onChange={(e) =>
                            setProfileFormData({
                              ...profileFormData,
                              email: e.target.value,
                            })
                          }
                          required
                        />
                      </div>

                      <div className="col-md-6">
                        <label className="form-label fw-semibold text-lg mb-12">
                          Phone
                        </label>
                        <input
                          className="form-control common-input"
                          type="tel"
                          value={profileFormData.mobile}
                          onChange={(e) =>
                            setProfileFormData({
                              ...profileFormData,
                              mobile: e.target.value,
                            })
                          }
                          required
                        />
                      </div>

                      <div className="col-md-6">
                        <label className="form-label fw-semibold text-lg mb-12">
                          Gender
                        </label>
                        <select
                          className="form-select common-input"
                          value={profileFormData.gender}
                          onChange={(e) =>
                            setProfileFormData({
                              ...profileFormData,
                              gender: e.target.value,
                            })
                          }
                          required
                        >
                          <option value="">Select Gender</option>
                          <option value="Male">Male</option>
                          <option value="Female">Female</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <label className="form-label fw-semibold text-lg mb-12">
                        Address
                      </label>
                      <input
                        className="form-control common-input"
                        value={profileFormData.address}
                        onChange={(e) =>
                          setProfileFormData({
                            ...profileFormData,
                            address: e.target.value,
                          })
                        }
                        required
                      />
                    </div>

                    <div className="mt-48">
                      <button
                        type="submit"
                        className="btn btn-main px-48 py-16"
                      >
                        {loading ? "Updating..." : "Save Changes"}
                      </button>
                    </div>
                  </form>
                </div>
              )}

              {activeTab === "rewards" && (
                <div className="content-card">
                  <div className="d-flex justify-content-between mb-32">
                    <h4 className="h3 fw-bold text-neutral-900 mb-0">
                      Reward Points
                    </h4>
                  </div>
                  <div className="text-center p-48 rounded-20 bg-gradient shadow-lg mb-40">
                    <div className="display-4 fw-bold text-black mb-8">
                      {rewardPoints.total}
                    </div>
                    <div className="h5 text-black  mb-0">Total Points</div>
                  </div>
                  <h5 className="fw-bold text-lg mb-24">Recent Activity</h5>
                  <div className="table-responsive">
                    <table className="table table-hover">
                      <thead>
                        <tr>
                          <th>Date</th>
                          <th>Activity</th>
                          <th>Points</th>
                        </tr>
                      </thead>
                      <tbody>
                        {rewardPoints.history.map((h, i) => (
                          <tr key={i}>
                            <td>{h.date}</td>
                            <td>{h.description}</td>
                            <td
                              className={
                                h.points > 0
                                  ? "text-success fw-bold"
                                  : "text-danger fw-bold"
                              }
                            >
                              {h.points > 0 ? `+${h.points}` : h.points}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {activeTab === "orders" && (
                <div className="p-3">
                  {/* Tabs */}
                  <div className="d-flex flex-wrap justify-content-around gap-2 mb-4">
                    {["delivered", "processing", "cancelled"].map((status) => (
                      <button
                        key={status}
                        onClick={() => setOrderFilter(status)}
                        className={`px-4 py-2 border-0 rounded-pill ${
                          orderFilter === status
                            ? "bg-warning text-white"
                            : "bg-transparent text-warning"
                        }`}
                        style={{ fontWeight: "600" }}
                      >
                        {status}
                      </button>
                    ))}
                  </div>

                  {/* Orders */}
                  {paginatedOrders.map((order, i) => (
                    <div
                      key={i}
                      className="p-3 mb-4"
                      style={{
                        background: "#fff",
                        borderRadius: "15px",
                        boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
                      }}
                    >
                      {/* Top */}
                      <div className="d-flex justify-content-between text-muted mb-2">
                        <span>Order №{order.id}</span>
                        <span>{order.addDate.split("T")[0]}</span>
                      </div>

                      {/* Invoice */}
                      <div className="mb-1">
                        Invoice number: <strong>{order.invoiceNo}</strong>
                      </div>

                      {/* Qty + Total */}
                      <div className="d-flex justify-content-between mb-3">
                        <span>Quantity: {order.items}</span>
                        <span className="fw-bold">₹{order.netAmount}</span>
                      </div>

                      {/* Details + Status */}
                      <div className="d-flex justify-content-between align-items-center mb-2">
                        <button
                          className="btn btn-sm btn-primary"
                          onClick={() => handleViewDetails(order.invoiceNo)}
                        >
                          Details
                        </button>

                        <span
                          style={{
                            color:
                              getStatus(order) === "cancelled"
                                ? "red"
                                : "green",
                            fontWeight: "600",
                          }}
                        >
                          {getStatus(order) === "processing"
                            ? "Pending"
                            : getStatus(order)}
                        </span>
                      </div>

                      {getStatus(order) === "delivered" && (
                        <>
                          {order.returnStatus === 1 && (
                            <div className="text-muted mb-2">
                              {order.returnStatusText}
                            </div>
                          )}

                          {order.returnStatus === 0 && (
                            <button
                              className="btn btn-outline-warning w-100 rounded-pill"
                              onClick={() => {
                                setReturnOrderId(order.id);
                                setShowReturnModal(true);
                              }}
                            >
                              Return Order
                            </button>
                          )}
                        </>
                      )}

                      {/* Processing */}
                      {getStatus(order) === "processing" && (
                        <button
                          className="btn bg-danger w-100 rounded-pill"
                          onClick={() => {
                            setCancelOrderId(order.id);
                            setShowCancelModal(true);
                          }}
                        >
                          Cancel Order
                        </button>
                      )}

                      {/* Cancelled → no button */}
                    </div>
                  ))}

                  {/* Pagination */}
                  {totalPages > 1 && (
                    <div className="flex-center flex-wrap gap-8 mt-4 mb-4">
                      <button
                        onClick={goToPrevPage}
                        disabled={currentPage === 1}
                        className="page-link h-48 w-48 flex-center text-lg rounded-8 fw-medium text-neutral-600 border border-gray-100 hover-bg-main-600 hover-text-white disabled:opacity-50 disabled:cursor-not-allowed"
                      >
                        <i className="ph-bold ph-arrow-left" />
                      </button>

                      {Array.from(
                        { length: Math.min(5, totalPages) },
                        (_, i) => {
                          let pageNum;
                          if (totalPages <= 5) {
                            pageNum = i + 1;
                          } else if (currentPage <= 3) {
                            pageNum = i + 1;
                          } else if (currentPage >= totalPages - 2) {
                            pageNum = totalPages - 4 + i;
                          } else {
                            pageNum = currentPage - 2 + i;
                          }
                          return (
                            <button
                              key={pageNum}
                              onClick={() => goToPage(pageNum)}
                              className={`page-link h-48 w-48 flex-center text-md rounded-8 fw-medium border border-gray-100 ${
                                currentPage === pageNum
                                  ? "text-white bg-main-600 border-main-600"
                                  : "text-neutral-600 hover-bg-main-600 hover-text-white"
                              }`}
                            >
                              {pageNum}
                            </button>
                          );
                        },
                      )}

                      <button
                        onClick={goToNextPage}
                        disabled={currentPage === totalPages}
                        className="page-link h-48 w-48 flex-center text-lg rounded-8 fw-medium text-neutral-600 border border-gray-100 hover-bg-main-600 hover-text-white disabled:opacity-50 disabled:cursor-not-allowed"
                      >
                        <i className="ph-bold ph-arrow-right" />
                      </button>
                      <span className="text-sm text-neutral-600">
                        Page {currentPage} of {totalPages}
                      </span>
                    </div>
                  )}

                  {/* Empty State */}
                  {filteredOrders.length === 0 && (
                    <div className="text-center py-5 text-muted">
                      No orders found
                    </div>
                  )}
                </div>
              )}

              {activeTab === "address" && (
                <div className="content-card">
                  {showAddressForm && (
                    <div
                      style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        background: "rgba(0,0,0,0.5)",
                        zIndex: 9999,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                      onClick={() => setShowAddressForm(false)} // outside click close
                    >
                      {/* 👇 STOP CLICK CLOSE */}
                      <div
                        onClick={(e) => e.stopPropagation()}
                        style={{ width: "100%", maxWidth: "700px" }}
                      >
                        {/* 👇 TUMHARA SAME UI (NO CHANGE) */}
                        <div className="card mt-4 p-4">
                          <h5>{isEditMode ? "Edit Address" : "Add Address"}</h5>

                          <div className="row g-3">
                            <input
                              className="form-control"
                              placeholder="Full Name"
                              value={addressForm.name}
                              onChange={(e) =>
                                setAddressForm({
                                  ...addressForm,
                                  name: e.target.value,
                                })
                              }
                            />

                            <input
                              className="form-control"
                              placeholder="Email"
                              value={addressForm.email}
                              onChange={(e) =>
                                setAddressForm({
                                  ...addressForm,
                                  email: e.target.value,
                                })
                              }
                            />

                            <input
                              className="form-control"
                              placeholder="Phone"
                              value={addressForm.phone}
                              onChange={(e) =>
                                setAddressForm({
                                  ...addressForm,
                                  phone: e.target.value,
                                })
                              }
                            />

                            <select
                              className="form-control"
                              value={addressForm.country}
                              onChange={(e) => {
                                setAddressForm({
                                  ...addressForm,
                                  country: e.target.value,
                                  state: "",
                                  city: "",
                                });
                                getStates(e.target.value);
                              }}
                            >
                              <option>Select Country</option>
                              {countries.map((c) => (
                                <option key={c.countryID} value={c.countryID}>
                                  {c.countryName}
                                </option>
                              ))}
                            </select>

                            <select
                              className="form-control"
                              value={addressForm.state}
                              onChange={(e) => {
                                setAddressForm({
                                  ...addressForm,
                                  state: e.target.value,
                                  city: "",
                                });
                                getCities(e.target.value);
                              }}
                            >
                              <option>Select State</option>
                              {states.map((s) => (
                                <option key={s.stateID} value={s.stateID}>
                                  {s.stateName}
                                </option>
                              ))}
                            </select>

                            <select
                              className="form-control"
                              name="city"
                              value={addressForm.city}
                              disabled={!addressForm.state}
                              onChange={(e) =>
                                setAddressForm({
                                  ...addressForm,
                                  city: e.target.value,
                                })
                              }
                            >
                              <option>Select City</option>
                              {cities.map((item) => (
                                <option key={item.cityID} value={item.cityID}>
                                  {item.cityName}
                                </option>
                              ))}
                            </select>

                            <input
                              className="form-control"
                              placeholder="Pincode"
                              value={addressForm.pincode}
                              onChange={(e) =>
                                setAddressForm({
                                  ...addressForm,
                                  pincode: e.target.value,
                                })
                              }
                            />

                            <textarea
                              className="form-control"
                              placeholder="Full Address"
                              value={addressForm.address}
                              onChange={(e) =>
                                setAddressForm({
                                  ...addressForm,
                                  address: e.target.value,
                                })
                              }
                            />
                          </div>
                          <div className="mt-3">
                            <button
                              className="btn btn-secondary me-2"
                              onClick={() => setShowAddressForm(false)}
                            >
                              Cancel
                            </button>

                            <button
                              className={`btn btn-success ${isSaving ? "opacity-50" : ""}`}
                              onClick={handleSaveAddress}
                              disabled={isSaving}
                            >
                              {isSaving
                                ? "Saving..."
                                : isEditMode
                                  ? "Update"
                                  : "Save"}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  <div className="d-flex justify-content-between mb-32">
                    <h4 className="h3 fw-bold text-neutral-900 mb-0">
                      My Addresses
                    </h4>
                    <button
                      className="btn btn-primary"
                      onClick={() => {
                        setShowAddressForm(true);
                        setIsEditMode(false);
                        setAddressForm({
                          id: null,
                          name: "",
                          email: "",
                          phone: "",
                          country: "",
                          state: "",
                          city: "",
                          pincode: "",
                          address: "",
                        });
                      }}
                    >
                      + Add New
                    </button>{" "}
                  </div>
                  <div className="row g-4">
                    {addresses.length === 0 ? (
                      <div className="col-12">
                        <div className="text-center py-64">
                          <i className="ph ph-map-pin-line text-5xl text-gray-300 mb-16" />
                          <h6>No addresses found</h6>
                          <p className="text-muted">
                            Add your first address to continue
                          </p>
                        </div>
                      </div>
                    ) : (
                      addresses.map((addr) => (
                        <div key={addr.id} className="col-lg-6">
                          <div className="card h-100">
                            <div className="card-body">
                              <h6>{addr.name}</h6>
                              <p>
                                {`${addr.address || ""}, ${addr.cityName || ""}, ${addr.stateName || ""} ${addr.pinCode || ""}`.replace(
                                  /,\s*$/,
                                  "",
                                ) || "No address details"}
                              </p>
                              <p className="small text-muted">
                                {addr.mobile || addr.phone}
                              </p>
                              <div>
                                <div>
                                  {addr.isDefault && (
                                    <span className="badge bg-success me-2">
                                      Default
                                    </span>
                                  )}

                                  {/* 👇 YAHAN ADD KARO */}
                                  {!addr.isDefault && (
                                    <button
                                      className="btn btn-sm bg-success me-2"
                                      onClick={() => handleSetDefault(addr.id)}
                                    >
                                      Set as Default
                                    </button>
                                  )}
                                </div>
                                <button
                                  className="btn btn-sm bg-secondary me-6 mt-6"
                                  onClick={async () => {
                                    setShowAddressForm(true);
                                    setIsEditMode(true);
                                    setAddressForm({
                                      id: addr.id,
                                      name: addr.name || "",
                                      email: addr.email || "",
                                      phone: addr.mobile || "",
                                      country:
                                        addr.countryID || addr.country || "",
                                      state: addr.stateID || addr.state || "",
                                      city: addr.cityID || addr.city || "",
                                      pincode:
                                        addr.pinCode || addr.pincode || "",
                                      address: addr.address || "",
                                    });
                                    // Load states and cities for edit
                                    if (addr.countryID || addr.country) {
                                      await getStates(
                                        addr.countryID || addr.country,
                                      );
                                    }
                                    if (addr.stateID || addr.state) {
                                      await getCities(
                                        addr.stateID || addr.state,
                                      );
                                    }
                                  }}
                                >
                                  Edit
                                </button>
                                {/* <button
                                  className="btn btn-sm bg-danger mt-6"
                                  onClick={async () => {
                                    if (
                                      window.confirm("Delete this address?")
                                    ) {
                                      try {
                                        const res = await apiRequest(
                                          `/User/deleteAddress/${addr.id}`,
                                          "DELETE",
                                          null,
                                          {
                                            Authorization: `Bearer ${token}`,
                                          },
                                        );
                                        if (res?.data?.success) {
                                          successAlert("Address deleted");
                                          fetchAddresses();
                                        }
                                      } catch (err) {
                                        errorAlert("Delete failed");
                                      }
                                    }
                                  }}
                                >
                                  Delete
                                </button> */}
                              </div>
                            </div>
                          </div>
                        </div>
                      ))
                    )}
                  </div>
                </div>
              )}

              {activeTab === "settings" && (
                <div className="content-card">
                  <h4 className="h3 fw-bold text-neutral-900 mb-32">
                    Settings
                  </h4>
                  <div className="row">
                    <div className="col-md-6 mb-4">
                      <h6>Change Password</h6>
                      <form onSubmit={handlePasswordChange}>
                        <input
                          type="password"
                          className="form-control mb-3"
                          placeholder="Current Password"
                          value={passwordData.currentPassword}
                          onChange={(e) =>
                            setPasswordData({
                              ...passwordData,
                              currentPassword: e.target.value,
                            })
                          }
                        />

                        <input
                          type="password"
                          className="form-control mb-3"
                          placeholder="New Password"
                          value={passwordData.newPassword}
                          onChange={(e) =>
                            setPasswordData({
                              ...passwordData,
                              newPassword: e.target.value,
                            })
                          }
                        />

                        <input
                          type="password"
                          className="form-control mb-3"
                          placeholder="Confirm Password"
                          value={passwordData.confirmPassword}
                          onChange={(e) =>
                            setPasswordData({
                              ...passwordData,
                              confirmPassword: e.target.value,
                            })
                          }
                        />

                        <button className="btn btn-primary">
                          {loading ? "Updating..." : "Update Password"}
                        </button>
                      </form>
                    </div>
                  </div>
                </div>
              )}

              {activeTab === "legal" && (
                <div className="content-card">
                  <h4 className="h3 fw-bold text-neutral-900 mb-32">
                    Legal & Policies
                  </h4>

                  <div className="row g-4">
                    {legalLinks.length === 0 ? (
                      <p>Loading...</p>
                    ) : (
                      legalLinks.map((link, index) => {
                        const title = link.includes("privacy")
                          ? "Privacy Policy"
                          : link.includes("TERMS")
                            ? "Terms & Conditions"
                            : link.includes("Return")
                              ? "Return Policy"
                              : "Policy";

                        return (
                          <div key={index} className="col-md-6">
                            <div className="card h-100">
                              <div className="card-body">
                                <h6>{title}</h6>

                                <p className="text-muted small">
                                  Click below to view full details
                                </p>

                                <a
                                  href={link}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="btn bg-primary"
                                >
                                  Read More
                                </a>
                              </div>
                            </div>
                          </div>
                        );
                      })
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* 👇 YAHA DALNA HAI (IMPORTANT) */}
      {showCancelModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.5)",
            zIndex: 9999,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
          onClick={() => setShowCancelModal(false)}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="bg-white p-4 rounded"
            style={{ width: "90%", maxWidth: "400px" }}
          >
            <h5 className="mb-3">Cancel Order</h5>

            <textarea
              className="form-control mb-3"
              placeholder="Enter cancel reason..."
              value={cancelReason}
              onChange={(e) => setCancelReason(e.target.value)}
            />

            <div className="d-flex justify-content-end">
              <button
                className="btn btn-secondary me-2"
                onClick={() => setShowCancelModal(false)}
              >
                Close
              </button>

              <button className="btn btn-danger" onClick={handleCancelOrder}>
                Submit
              </button>
            </div>
          </div>
        </div>
      )}

      {showReturnModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.5)",
            zIndex: 9999,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
          onClick={() => setShowReturnModal(false)}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="bg-white p-4 rounded"
            style={{ width: "400px" }}
          >
            <h5 className="mb-3">Return Order</h5>

            <textarea
              className="form-control mb-3"
              placeholder="Enter return reason..."
              value={returnReason}
              onChange={(e) => setReturnReason(e.target.value)}
            />

            <div className="d-flex justify-content-end">
              <button
                className="btn btn-secondary me-2"
                onClick={() => setShowReturnModal(false)}
              >
                Close
              </button>

              <button className="btn btn-warning" onClick={handleReturnOrder}>
                Submit
              </button>
            </div>
          </div>
        </div>
      )}

      {showDetailsModal && selectedOrder && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.5)",
            zIndex: 9999,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
          onClick={() => setShowDetailsModal(false)}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="bg-white p-4 rounded"
            style={{ width: "500px" }}
          >
            <h5 className="mb-3">Order Details</h5>

            {/* Product Image */}
            <div className="text-center mb-3">
              <img
                src={`${process.env.REACT_APP_IMAGE_BASE_URL}${selectedOrder.imageUrl}`}
                alt="product"
                style={{ width: "120px", borderRadius: "10px" }}
              />
            </div>

            {/* Product Name */}
            <p>
              <strong>Product:</strong> {selectedOrder.productName}
            </p>

            {/* Order Info */}
            <p>
              <strong>Order ID:</strong> {selectedOrder.id}
            </p>
            <p>
              <strong>Invoice:</strong> {selectedOrder.invoiceNo}
            </p>
            <p>
              <strong>Date:</strong> {selectedOrder.addDate.split("T")[0]}
            </p>

            {/* Quantity & Price */}
            <p>
              <strong>Quantity:</strong> {selectedOrder.qty}
            </p>
            <p>
              <strong>Price:</strong> ₹{selectedOrder.pricePerUnit}
            </p>
            <p>
              <strong>Total:</strong> ₹{selectedOrder.totalPrice}
            </p>

            {/* Payment */}
            <p>
              <strong>Payment Mode:</strong> {selectedOrder.paymentMode}
            </p>

            {/* Status */}
            <p>
              <strong>Status:</strong> {getStatus(selectedOrder)}
            </p>
            {/* ⭐ Rating Section */}
            {getStatus(selectedOrder) === "delivered" && (
              <div
                className="mt-4 p-3"
                style={{
                  borderTop: "1px solid #eee",
                  background: "#fafafa",
                  borderRadius: "10px",
                }}
              >
                <h6>Rate this Product</h6>

                {/* ⭐ Stars */}
                <div className="mb-2">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <span
                      key={star}
                      style={{
                        cursor: "pointer",
                        fontSize: "24px",
                        color:
                          star <= (ratingMap[selectedOrder.id]?.rating || 0)
                            ? "#ffc107"
                            : "#ddd",
                      }}
                      onClick={() =>
                        setRatingMap({
                          ...ratingMap,
                          [selectedOrder.id]: {
                            ...ratingMap[selectedOrder.id],
                            rating: star,
                          },
                        })
                      }
                    >
                      ★
                    </span>
                  ))}
                </div>

                {/* Review */}
                <textarea
                  className="form-control mb-2"
                  placeholder="Write your review..."
                  value={ratingMap[selectedOrder.id]?.remark || ""}
                  onChange={(e) =>
                    setRatingMap({
                      ...ratingMap,
                      [selectedOrder.id]: {
                        ...ratingMap[selectedOrder.id],
                        remark: e.target.value,
                      },
                    })
                  }
                />

                {/* Button */}
                <button
                  className="btn btn-success w-100"
                  onClick={() => handleSubmitRating(selectedOrder)}
                >
                  Submit Review
                </button>
              </div>
            )}
            {/* Return Status */}
            {selectedOrder.returnStatus === 1 && (
              <p className="text-warning">{selectedOrder.returnStatusText}</p>
            )}

            <div className="text-end mt-3">
              <button
                className="btn btn-secondary"
                onClick={() => setShowDetailsModal(false)}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {/* New Order Details Modal */}

      {showOrderDetailsModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.5)",
            zIndex: 10000,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
          onClick={() => {
            setShowOrderDetailsModal(false);
            setOrderDetails(null);
            setOrderDetailsError("");
          }}
        >
          {/* Modal */}
          <div
            onClick={(e) => e.stopPropagation()}
            className="order-details-modal"
          >
            {/* Header */}
            <div className="order-modal-header">
              <div>
                <h3>Order Details</h3>
                <p>Invoice #{orderDetails?.invoiceNo}</p>
              </div>

              <button
                className="close-btn"
                onClick={() => {
                  setShowOrderDetailsModal(false);
                  setOrderDetails(null);
                  setOrderDetailsError("");
                }}
              >
                <i className="ph ph-x"></i>
              </button>
            </div>

            <div className="order-modal-body">
              {detailsLoading ? (
                <div className="loading-box">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              ) : orderDetailsError ? (
                <div className="error-box">
                  <i className="ph ph-warning-circle"></i>
                  <h5>{orderDetailsError}</h5>
                </div>
              ) : orderDetails && orderDetails.id > 0 ? (
                <>
                  {/* Summary */}
                  <div className="order-card">
                    <div className="section-title">
                      <i className="ph ph-package"></i>
                      <h4>Order Summary</h4>
                    </div>

                    <div className="row g-3">
                      <div className="col-md-4">
                        <div className="info-box">
                          <small>Order ID</small>
                          <h5>#{orderDetails.id}</h5>
                        </div>
                      </div>

                      <div className="col-md-4">
                        <div className="info-box">
                          <small>Payment Mode</small>
                          <h5>{orderDetails.paymentMode}</h5>
                        </div>
                      </div>

                      <div className="col-md-4">
                        <div className="info-box">
                          <small>Net Amount</small>
                          <h5 className="price-text">
                            ₹{orderDetails.netAmount}
                          </h5>
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="info-box">
                          <small>Invoice No</small>
                          <h5>{orderDetails.invoiceNo}</h5>
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="info-box">
                          <small>Date</small>
                          <h5>
                            {orderDetails.addDate
                              ? new Date(
                                  orderDetails.addDate,
                                ).toLocaleDateString("en-IN")
                              : "N/A"}
                          </h5>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Items */}
                  <div className="order-card">
                    <div className="section-title">
                      <i className="ph ph-shopping-cart"></i>
                      <h4>Order Items</h4>
                    </div>

                    <div className="table-responsive">
                      <table className="table order-table align-middle">
                        <thead>
                          <tr>
                            <th>Product</th>
                            <th className="text-center">Qty</th>
                            <th className="text-center">Price</th>
                            <th className="text-end">Total</th>
                          </tr>
                        </thead>

                        <tbody>
                          {orderDetails.items.map((item, idx) => (
                            <tr key={idx}>
                              <td className="fw-semibold">
                                {item.productName || item.name}
                              </td>

                              <td className="text-center">
                                <span className="qty-badge">
                                  {item.qty || item.quantity}
                                </span>
                              </td>

                              <td className="text-center text-primary fw-semibold">
                                ₹{item.pricePerUnit || item.price}
                              </td>

                              <td className="text-end text-success fw-bold">
                                ₹{item.totalPrice || item.total}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </>
              ) : (
                <div className="error-box">
                  <i className="ph ph-warning-circle"></i>
                  <h5>Unable to load order details</h5>
                </div>
              )}

              {/* Footer */}
              <div className="footer-btn">
                <button
                  className="btn btn-primary px-4 py-2 rounded-pill"
                  onClick={() => {
                    setShowOrderDetailsModal(false);
                    setOrderDetails(null);
                    setOrderDetailsError("");
                  }}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default User;
